import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { PortModel } from '@data-layer/models/common';
import { CodeRepository, SelfFilerRepository } from '@data-layer/repositories';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { take } from 'rxjs/operators';
import { UtilsHelper } from '@helpers/utils-helper';

@Component({
  selector: 'self-filer-code-add-additional-ports',
  templateUrl: './self-filer-code-add-additional-ports.component.html',
  styleUrls: ['./self-filer-code-add-additional-ports.component.scss'],
})
export class SelfFilerCodeAddAdditionalPortsComponent implements OnInit, OnChanges {
  @Input() public filerCode: string = '';
  @Input() public mainPort: PortModel;
  @Input() public additionalPorts: PortModel[] = [];
  @Input() public companyId: number;

  @Output() public update: EventEmitter<any> = new EventEmitter();

  public filerCodeControl: UntypedFormControl = new UntypedFormControl();
  public additionalPortControl: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  public addAdditionalPortFormOpen: boolean = false;
  public CUSTOM_MASK = CUSTOM_MASK;
  constructor(private codeRepository: CodeRepository, private selfFilerRepository: SelfFilerRepository) {}

  public ngOnInit(): void {
    this.filerCodeControl.disable();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.filerCode) {
      this.filerCodeControl.patchValue(this.filerCode);
    }
  }

  public openAddPort() {
    this.addAdditionalPortFormOpen = true;
  }

  public setMainPort(code: PortModel['code']) {
    this.selfFilerRepository
      .setMainPort(code, this.companyId)
      .pipe(take(1))
      .subscribe(() => {
        this.update.emit();
        this.additionalPortControl.reset(null);
        this.addAdditionalPortFormOpen = false;
      });
  }

  public deletePort(code: PortModel['code']) {
    this.additionalPorts = this.additionalPorts.filter((port) => port.code !== code);
    this.savePort();
  }

  public savePort() {
    const ports: Array<PortModel['code']> = this.additionalPorts.map((port) => port.code);
    if (this.additionalPortControl.value && this.additionalPortControl.value.code) {
      ports.push(this.additionalPortControl.value.code);
    }
    if (this.mainPort && this.mainPort.code) {
      ports.push(this.mainPort.code);
    }

    this.selfFilerRepository
      .updateAdditionalPorts(UtilsHelper.uniq<string>(ports), this.companyId)
      .pipe(take(1))
      .subscribe(() => {
        this.update.emit();
        this.additionalPortControl.reset(null);
        this.addAdditionalPortFormOpen = false;
      });
  }

  public searchPort() {
    return this.codeRepository.searchDomesticPorts.bind(this.codeRepository);
  }
}
